import React, { useState } from "react";

import CssBaseline from "@mui/material/CssBaseline";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";

import Appbar from "../layout/Appbar";
import Sidenav from "../layout/Sidenav";
import { Breadcrumb } from "./Common";

function CommonLayout({ title, breadcrumbArr = [], loading = false, children, autoScroll = false }) {
  const [open, setOpen] = useState(false);

  const toggleDrawer = () => {
    setOpen(!open);
  };

  return (
    <>
      <Box
        sx={{
          display: "flex",
          // flexDirection: "column",
          backgroundColor: (theme) => {
            return theme.palette.TiffanyBlue.main;
          },
          overflow: "hidden",
          height: "100vh",
        }}
      >
        <Sidenav open={open} toggleDrawer={toggleDrawer} />

        <Box
          sx={(theme) => ({
            minWidth: "calc(100% - 240px)",
            maxWidth: "calc(100% - 80px)",
            flexGrow: "1",
            [theme.breakpoints.down("769")]: {
              marginLeft: "0",
              maxWidth: "100%",
            },
          })}
        >
          <CssBaseline />
          <Appbar open={open} title={title} toggleDrawer={toggleDrawer} configData={breadcrumbArr} loading={loading} />
          <Box
            component="main"
            sx={{
              backgroundColor: (theme) => {
                return theme.palette.TiffanyBlue.main;
              },
              // overflow: "hidden",
              height: "calc(100vh - 45px)",
              marginTop: "1px",
              ...(autoScroll ? { overflow: "auto" } : {}),
            }}
          >
            {breadcrumbArr.length ? (
              <Paper
                sx={{
                  backgroundColor: "white",
                  boxShadow: "0px 3px 40px #4343430A",
                  p: "4px 10px 4px 30px",
                  minHeight: "20px",
                  zIndex: (theme) => {
                    return theme.zIndex.drawer;
                  },
                  position: "relative",
                }}
              >
                <Breadcrumb configData={breadcrumbArr} loading={loading} />
              </Paper>
            ) : (
              ""
            )}
            <>{children}</>
          </Box>
        </Box>
      </Box>
    </>
  );
}

export default CommonLayout;
